import { Lightning } from '@lightningjs/sdk';
import { colors, getInitialStyle } from './overlay.style';
import { TRANSPARENT } from '../../../tornado/utils/colors';

export class Overlay extends Lightning.Component {
  static _template() {
    return getInitialStyle();
  }

  get colorMode() {
    return this._colorMode;
  }

  set colorMode(value) {
    this._colorMode = value;

    this.patch({
      color: colors.background[this._colorMode],
    });
  }

  set displayBackdrop(value) {
    this.color = value ? colors.background[this._colorMode] : TRANSPARENT;
  }

  set displayTop(value) {
    this.tag('Top').visible = value;
  }

  set displayBottom(value) {
    this.tag('Bottom').visible = value;
  }
}
